import { render, staticRenderFns } from "./CardCustomer.vue?vue&type=template&id=6d0d6978&"
import script from "./CardCustomer.vue?vue&type=script&lang=js&"
export * from "./CardCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports